import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ShippingCharge, ShippingChargesCriteria } from '../models';
import { DistributionDetailsState, DistributionState } from '../store';
import { takeWhile } from 'rxjs/operators';

import * as fromStore from '../store';

@Component({
  selector: 'opus-distribution-landing',
  templateUrl: './distribution-landing.component.html'
})
export class DistributionLandingComponent implements OnInit, OnDestroy {
  @ViewChild('editor', { static: true }) editor;

  private _alive = true;
  criteria: ShippingChargesCriteria;
  shippingCharges$: Observable<ShippingCharge[]>;
  vm: DistributionDetailsState;
  vm$: Observable<DistributionDetailsState>;
  updatingShippingCharges = false;
  isEditing = false;

  constructor(private store: Store<DistributionState>, private cdr: ChangeDetectorRef) {
    this.vm$ = this.store.pipe(select(fromStore.getDistributionDetailsState));
    this.shippingCharges$ = this.store.pipe(select(fromStore.getShippingCharges));
  }

  ngOnInit(): void {
    this.vm$.pipe(takeWhile(() => this._alive)).subscribe(vm => {
      this.vm = vm;
      if (this.updatingShippingCharges) {
        this.updatingShippingCharges = false;
        this.isEditing = false;
      }
    });

    this.shippingCharges$.pipe(takeWhile(() => this._alive));

    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this._alive = false;
    this.cdr.detach();
  }

  onCriteriaChange(criteria: ShippingChargesCriteria) {
    this.criteria = criteria;
    this.store.dispatch(new fromStore.LoadShippingCharges(criteria));
  }

  onSaveChanges() {
    console.log('ShippingChargesTableComponent.onSaveChanges()...');

    const controls = this.editor.getChanges();
    let newArray = [];
    let changed = newArray.concat(
      controls
        .filter(g => g.controls.rentalCategoryCode !== null && g.controls.state !== null)
        .map(g => {
          const pic: ShippingCharge = {
            rentalCategoryCode: g.controls.rentalCategoryCode.value,
            rentalCategoryName: g.controls.rentalCategoryName.value,
            state: g.controls.state.value,
            ground: g.controls.ground.value,
            overnight: g.controls.overnight.value,
            twoDay: g.controls.twoDay.value
          };

          return pic;
        })
    );

    this.updatingShippingCharges = true;
    this.store.dispatch(new fromStore.UpdateShippingCharges({ changed }));
    /*this.store.dispatch(new fromStore.LoadShippingCharges(this.criteria));*/
  }

  onToggleEdit() {
    this.isEditing = !this.isEditing;
  }
}
